import { OverviewTableTemplate } from './OverviewTableTemplate'
import { withOverviewTableTemplate } from './withOverviewTableTemplate'

const ConnectedOverviewTableTemplate = withOverviewTableTemplate(
  OverviewTableTemplate
)

export { ConnectedOverviewTableTemplate as OverviewTableTemplate }
